import React, { useState } from "react";
import { Modal, ModalHeader } from "reactstrap";
import { useFormik } from "formik";
import { updateAgencyLTA } from "common/services/ltas.service";
import LTAForm from "pages/LTAs/components/LTAForm";
import {
  buildLTAFormData,
  ltaToFormValues,
  ltaValidationSchema,
} from "pages/LTAs/components/ltaFormValues";
import { toast } from "react-toastify";
import { getApiErrorMessage, LTA_FIELD_LABELS } from "common/lib/apiErrors";

const UpdateAgencyLTA: React.FC<{
  toggle: () => void;
  isModalOpen: boolean;
  fetchData: () => void;
  selectedRecord: any;
}> = ({ toggle, isModalOpen, fetchData, selectedRecord }) => {
  const [loading, setLoading] = useState<boolean>(false);

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: ltaToFormValues(selectedRecord),
    validationSchema: ltaValidationSchema,
    onSubmit: async (values: any) => {
      setLoading(true);
      try {
        await updateAgencyLTA(
          selectedRecord?.id,
          buildLTAFormData(values, { isUpdate: true })
        );
        fetchData();
        validation.resetForm();
        toggle();
        toast.success("LTA updated successfully", {});
      } catch (e: any) {
        toast.error(
          getApiErrorMessage(e, "LTA update failed", LTA_FIELD_LABELS)
        );
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <Modal
      id="showModal"
      size="lg"
      isOpen={isModalOpen}
      toggle={toggle}
      centered
    >
      <ModalHeader className="bg-light p-3" toggle={toggle}>
        Update Long Term Agreement
      </ModalHeader>

      <LTAForm
        validation={validation}
        isUpdate
        loading={loading}
        toggle={toggle}
        hideLeadAgency
      />
    </Modal>
  );
};

export default UpdateAgencyLTA;
